<template>
    <section>
        <b-row class="justify-content-between mt-2">
            <b-col cols="2">
              <div class="buttom-container">
                <div class="d-flex justify-content-between">
                  <a class="input-header-txt">Print Comments</a>
                </div>
                <lookup-dropdown
                  :options="printComments"
                  moduleName="printComments"
                  propKey="name"
                  resource="PrintComments"
                  lookupId="19"
                  class="mb-2"
                  @change="onPrintCommentChange"
                />
                <b-textarea rows="5" v-model.trim="serviceOrder.comments" />
              </div>
              <div class="buttom-container mt-2">
                <b-form-group label="Internal Comments">
                  <b-textarea rows="5" v-model="serviceOrder.internalComments" />
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="3">
            </b-col>
            <b-col cols="5">
              <b-tabs>
                <b-tab title="Summary" active>
                  <lower-summary-tab v-bind:quote="serviceOrder" :page="'service-order'" :isPaid="isPaid" isWorkOrderView @credit-applied="$emit('credit-applied')" />
                </b-tab>
                <!-- <b-tab>
                  <template v-slot:title>
                    Charges &nbsp;<b-badge variant="primary">{{ charges.length }}</b-badge>
                  </template>
                  <charges-list :serviceOrderId="serviceOrder.id" isVendor />
                </b-tab> -->
                <b-tab>
                  <template v-slot:title>
                    Adjustments &nbsp; <b-badge variant="primary">{{ charges.length }}</b-badge>
                  </template>
                  <order-expenses-list :serviceOrderId="serviceOrderId" @updateExpense="$emit('on-refresh')"  />
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
    </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import LowerSummaryTab from '@/shared/components/LowerSummaryTab';
import ChargesList from '@/shared/components/ChargesList/index';
import OrderExpensesList from '@/shared/components/OrderExpense';

export default {
    components: {
      LowerSummaryTab,
      ChargesList,
      OrderExpensesList
    },
    props: {
      serviceOrderLine: {
        type: Object,
        default: () => {}
      },
      serviceOrder: {
        type: Object,
        default: () => {}
      },
    },
    computed: {
      ...mapGetters('lookup', ['printComments']),
      ...mapState('serviceOrders', ['charges']),
      ...mapGetters('serviceOrderLineItems', ['serviceOrderLineItemsList']),
      isPaid(){
        return (this.serviceOrder.isPaid && this.serviceOrderLineItemsList.length > 0)
      },
      serviceOrderId() {
        return this.$route.params.id;
      }
    },
    methods: {
      onPrintCommentChange({ text, name }) {
        this.serviceOrder.comments = (this.serviceOrder.comments) ? this.serviceOrder.comments + '\n' + (text || name) : (text || name);
      },
    }

}
</script>
